var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tab-body"},_vm._l((_vm.list),function(item){return _c('el-button',{key:item.id,class:item.id == _vm.value ? 'tab-span-check' : 'tab-span',attrs:{"type":"text","disabled":_vm.loading},on:{"click":function($event){return _vm.setTab(item.id)}}},[_vm._v(_vm._s(item.name))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }